// Kindle Research Pro - Variant B: BSR Teaser
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Calculator, Lock } from 'lucide-react';
import { Layout } from '../Layout';

export default function KindleVariantB({
  PaywallHero, getVariantBadge, sharedProps,
  bsrInput, setBsrInput, bsrResult, bsrRemaining, handleCalculateBsr, categories
}) {
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="container mx-auto px-4 py-12">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Kindle Research Pro</h1>
              <p className="text-gray-600">Try our BSR Calculator free - 5 calculations per day</p>
            </div>
            {getVariantBadge()}
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <Card className="border-2 border-blue-200">
              <CardHeader className="bg-blue-50">
                <CardTitle className="flex items-center gap-2">
                  <Calculator className="w-5 h-5 text-blue-600" />
                  BSR Sales Calculator
                  <span className="text-sm font-normal text-blue-600 ml-auto">
                    {bsrRemaining !== null ? `${bsrRemaining} uses left today` : '5/day free'}
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Enter Best Seller Rank (BSR)</label>
                    <div className="flex gap-2">
                      <Input 
                        type="number"
                        value={bsrInput}
                        onChange={e => setBsrInput(e.target.value)}
                        placeholder="e.g., 5000"
                        data-testid="bsr-input-variant-b"
                      />
                      <Button onClick={handleCalculateBsr}>Calculate</Button>
                    </div>
                  </div>
                  {bsrResult && (
                    <div className="bg-gray-50 p-4 rounded-lg space-y-3">
                      <div className="text-center">
                        <div className="text-sm text-gray-600">BSR #{bsrResult.bsr.toLocaleString()}</div>
                        <div className="text-xl font-bold text-purple-600">{bsrResult.interpretation}</div>
                      </div>
                      <div className="grid grid-cols-3 gap-3 text-center">
                        <div className="bg-white p-3 rounded-lg">
                          <div className="text-lg font-bold">{bsrResult.estimated_daily_sales}</div>
                          <div className="text-xs text-gray-600">Daily Sales</div>
                        </div>
                        <div className="bg-white p-3 rounded-lg">
                          <div className="text-lg font-bold">{bsrResult.estimated_monthly_sales}</div>
                          <div className="text-xs text-gray-600">Monthly</div>
                        </div>
                        <div className="bg-white p-3 rounded-lg">
                          <div className="text-lg font-bold">${bsrResult.revenue_estimates.monthly}</div>
                          <div className="text-xs text-gray-600">Monthly Rev</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>

            <PaywallHero 
              variant="B"
              compact={true}
              {...sharedProps}
            />
          </div>

          <Card className="mt-8">
            <CardHeader>
              <CardTitle>Kindle Categories Reference</CardTitle>
              <CardDescription>Browse categories to find your niche</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid md:grid-cols-3 gap-4">
                {Object.entries(categories).map(([cat, subcats]) => (
                  <div key={cat} className="p-4 bg-gray-50 rounded-lg">
                    <div className="font-semibold text-purple-700 mb-2">{cat}</div>
                    <div className="flex flex-wrap gap-1">
                      {subcats.slice(0, 5).map(sub => (
                        <span key={sub} className="text-xs px-2 py-1 bg-white rounded">{sub}</span>
                      ))}
                      {subcats.length > 5 && <span className="text-xs text-gray-500">+{subcats.length - 5} more</span>}
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4 p-4 bg-purple-50 rounded-lg text-center">
                <Lock className="w-5 h-5 inline mr-2 text-purple-600" />
                <span className="text-purple-700">Upgrade to save niches, track books, and use AI features</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
